import * as Types from '../../graphql/types.generated';

import { gql } from '@apollo/client';
import { DiscountFragmentDoc } from '../discount/discount.gql.generated';
import { ProgressDataFragmentDoc, SelectedGiftsFragmentDoc } from '../campaign/campaign.gql.generated';
import { RequirementFragmentDoc } from '../requirement/requirement.gql.generated';
import { GiftFragmentDoc } from '../gift/gift.gql.generated';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: any;
  /** A valid URL, transported as a string */
  File: any;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
};

export type AddItemToQuotationInput = {
  note?: InputMaybe<Scalars['String']>;
  productName: Scalars['String'];
  quantity: Scalars['Int'];
  quotationId: Scalars['ID'];
  vatPrice?: InputMaybe<Scalars['Int']>;
  vatWholeSalePrice?: InputMaybe<Scalars['Int']>;
};

export type AddToListInput = {
  listId: Scalars['ID'];
  orderItemIds: Array<Scalars['ID']>;
};

export type AddUserPermissionInput = {
  permissionName: Scalars['String'];
  selectedUserId: Scalars['ID'];
};

export type Address = {
  addressType: Scalars['String'];
  body: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  customer: Customer;
  id: Scalars['ID'];
  receiver?: Maybe<Scalars['String']>;
  receiverPhoneNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type AppConfiguration = {
  id: Scalars['ID'];
  keyName?: Maybe<Scalars['String']>;
  keyValue?: Maybe<Scalars['String']>;
  otherSettings?: Maybe<Scalars['JSON']>;
};

export type ApplyListToCartInput = {
  listId: Scalars['ID'];
};

export type Authentication = {
  token: Scalars['String'];
  user: User;
};

export type Balance = {
  amount?: Maybe<Scalars['BigInt']>;
  deposit?: Maybe<Scalars['Float']>;
  depositWithoutCreditLimit?: Maybe<Scalars['Float']>;
  incurredDebt?: Maybe<Scalars['BigInt']>;
  nextPaymentDate?: Maybe<Scalars['ISO8601Date']>;
};

export type BankAccount = {
  accountName: Scalars['String'];
  accountNo: Scalars['String'];
  bankName: Scalars['String'];
  id: Scalars['ID'];
};

export type Banner = {
  createdAt: Scalars['ISO8601DateTime'];
  fromDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['String']>;
  toDate: Scalars['ISO8601Date'];
  updatedAt: Scalars['ISO8601DateTime'];
  url?: Maybe<Scalars['String']>;
};

export type BonusSale = {
  bonuses?: Maybe<Scalars['Int']>;
  bonusesPlan?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  finalized?: Maybe<Scalars['Boolean']>;
  fromDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  nanocoConditions?: Maybe<Scalars['BigInt']>;
  nanocoTotal?: Maybe<Scalars['BigInt']>;
  nanocoTotalConfirmed?: Maybe<Scalars['BigInt']>;
  percent?: Maybe<Scalars['Int']>;
  promotionName: Scalars['String'];
  status: Scalars['String'];
  toDate: Scalars['ISO8601Date'];
  total?: Maybe<Scalars['BigInt']>;
  totalConditions?: Maybe<Scalars['BigInt']>;
  totalConfirmed?: Maybe<Scalars['BigInt']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type Branch = {
  createdAt: Scalars['ISO8601DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type Brand = {
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type BuildOrderItemsInWarehouseInput = {
  orderId: Scalars['ID'];
};

export type CampaignPropratedPrice = {
  id: Scalars['ID'];
  propratedPrice: Scalars['Int'];
};

export type CancelInventoryCheckInput = {
  variantIds: Array<Scalars['ID']>;
};

export type CancelOrderInput = {
  orderId: Scalars['ID'];
  reasons: Array<Scalars['String']>;
};

export type Category = {
  children?: Maybe<Array<Category>>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isDeepestChild?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parent?: Maybe<Category>;
  products?: Maybe<ProductConnection>;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type CategoryProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Array<Scalars['String']>>;
  before?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  optionValueIds?: InputMaybe<Array<Scalars['ID']>>;
  priceGte?: InputMaybe<Scalars['Int']>;
  priceLte?: InputMaybe<Scalars['Int']>;
  validPrice?: InputMaybe<Scalars['Boolean']>;
};

export type CategoryDiscount = {
  appliedVariants?: Maybe<VariantConnection>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};


export type CategoryDiscountAppliedVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryId: Scalars['ID'];
  discountProgramId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ChangePasswordInput = {
  otp: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};

export type ChangeUserStatusInput = {
  selectedUserId: Scalars['ID'];
  status: Scalars['String'];
};

export type ChangeUserTypeInput = {
  selectedUserId: Scalars['ID'];
  userType: Scalars['String'];
};

export type CheckInventoryByListVariants = {
  errors: Array<Scalars['String']>;
  listAvailableQuantity: Array<InventoryByVariant>;
};

export type CheckInventoryByListVariantsInput = {
  count?: InputMaybe<Scalars['Boolean']>;
  file: Scalars['File'];
  fileName: Scalars['String'];
};

export type CheckoutGiftInput = {
  note?: InputMaybe<Scalars['String']>;
  selectedGiftIds?: InputMaybe<Array<Scalars['ID']>>;
  shippingAddressId: Scalars['ID'];
  slocId?: InputMaybe<Scalars['ID']>;
};

export type CheckoutInput = {
  estimateDeliveredAt: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  selectedGiftIds?: InputMaybe<Array<Scalars['ID']>>;
  shippingAddressId: Scalars['ID'];
  slocId?: InputMaybe<Scalars['ID']>;
};

export type Company = {
  address?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  sapCode: Scalars['String'];
  shortName?: Maybe<Scalars['String']>;
};

export type Country = {
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type CreatePasswordInput = {
  createPasswordToken: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  userId: Scalars['ID'];
};

export type CreateQuotationInput = {
  customerId?: InputMaybe<Scalars['ID']>;
  date: Scalars['ISO8601DateTime'];
  quotationCode: Scalars['String'];
  salesEmployeeId: Scalars['ID'];
  salesOrgId: Scalars['ID'];
  serveyCustomerId?: InputMaybe<Scalars['ID']>;
};

export type CreateServeyCustomerInput = {
  address: Scalars['String'];
  companyName: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  salesOrgId: Scalars['ID'];
};

export type CreateShippingAddressInput = {
  body: Scalars['String'];
  receiver: Scalars['String'];
  receiverPhoneNumber: Scalars['String'];
};

export type CreateUserInput = {
  companyDepartment?: InputMaybe<Scalars['String']>;
  function?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  userType: Scalars['String'];
};

export type Customer = {
  billingAddress?: Maybe<Address>;
  createdAt: Scalars['ISO8601DateTime'];
  emails: Array<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumbers?: Maybe<Array<Scalars['String']>>;
  qrImage?: Maybe<Scalars['String']>;
  salesOrg?: Maybe<SalesOrg>;
  sapId: Scalars['String'];
  shippingAddresses: Array<Address>;
  shortName?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  users?: Maybe<Array<User>>;
};

/** The connection type for Customer. */
export type CustomerConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Customer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CustomerEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Customer>;
};

export type DeleteItemsInListInput = {
  itemIds: Array<Scalars['ID']>;
  listId: Scalars['ID'];
};

export type DeleteSelectedGiftsInput = {
  campaignIds: Array<Scalars['ID']>;
};

export type DeleteShoppingListsInput = {
  shoppingListIds: Array<Scalars['ID']>;
};

export type DeleteWarrantyOrderInput = {
  id: Scalars['ID'];
};

export type DeleteWarrantyOrderItemInput = {
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteWarrantyOrderItemMutation */
export type DeleteWarrantyOrderItemMutationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

/** Autogenerated return type of DeleteWarrantyOrderMutation */
export type DeleteWarrantyOrderMutationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type Discount = {
  discountType?: Maybe<Scalars['String']>;
  discountValue?: Maybe<Scalars['Int']>;
  vatDiscountValue?: Maybe<Scalars['Float']>;
};

export type DiscountDetails = {
  adjustment: Scalars['Float'];
  applied?: Maybe<Scalars['Boolean']>;
  flatAmount?: Maybe<Scalars['Int']>;
  fromDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  percent?: Maybe<Scalars['Float']>;
  requirements?: Maybe<Scalars['JSON']>;
  sapCode?: Maybe<Scalars['String']>;
  toDate: Scalars['ISO8601Date'];
  type?: Maybe<Scalars['String']>;
  vatAdjustment: Scalars['Float'];
};

export type DispatchCheckoutInput = {
  note?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  selectedGiftIds?: InputMaybe<Array<Scalars['ID']>>;
  shippingAddressId: Scalars['ID'];
  slocId?: InputMaybe<Scalars['ID']>;
};

export type DistributionChannel = {
  id: Scalars['ID'];
  name: Scalars['String'];
  sapId: Scalars['String'];
};

export type EmptyInput = {
  emptyInput: Scalars['Boolean'];
};

export type EstimateDetails = {
  availableQuantity?: Maybe<Scalars['Int']>;
  dateArrival?: Maybe<Scalars['ISO8601Date']>;
  dispatchedQuantity?: Maybe<Scalars['Int']>;
  eta?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  notEnoughInventory?: Maybe<Scalars['Boolean']>;
  priority?: Maybe<Scalars['Int']>;
  totalDayDispatch?: Maybe<Scalars['Int']>;
  warehouseDelivery?: Maybe<Sloc>;
};

export type EstimateTimeArrival = {
  estimateTimeArrivalItems: Array<EstimateTimeArrivalItem>;
  id: Scalars['ID'];
  warehouseReceipt: Sloc;
};

export type EstimateTimeArrivalItem = {
  availableInBranch?: Maybe<Scalars['Boolean']>;
  availableInWarehouse?: Maybe<Scalars['Boolean']>;
  availableQuantity?: Maybe<Scalars['Int']>;
  dispatchedQuantity?: Maybe<Scalars['Int']>;
  estimateDetails: Array<EstimateDetails>;
  eta?: Maybe<Scalars['ISO8601Date']>;
  giftQuantity: Scalars['Int'];
  notEnoughInventory?: Maybe<Scalars['Boolean']>;
  orderQuantity: Scalars['Int'];
  variant: Variant;
};

export type ExecutionOrder = {
  createdAt: Scalars['ISO8601DateTime'];
  eta?: Maybe<Scalars['ISO8601Date']>;
  executionOrderGiftItems: Array<ExecutionOrderGiftItem>;
  executionOrderItems: Array<ExecutionOrderItem>;
  id: Scalars['ID'];
  order: Order;
  orderIdInWarehouse?: Maybe<Scalars['ID']>;
  selectedGiftsTypeBInWarehouse?: Maybe<Array<SelectedGift>>;
  total: Scalars['BigInt'];
  totalQuantity: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ExecutionOrderGiftItem = {
  createdAt: Scalars['ISO8601DateTime'];
  eta?: Maybe<Scalars['ISO8601Date']>;
  executionOrder: ExecutionOrder;
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  status: Scalars['String'];
  typeACampaignId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['ISO8601DateTime'];
  variant: Variant;
};

export type ExecutionOrderItem = {
  createdAt: Scalars['ISO8601DateTime'];
  eta?: Maybe<Scalars['ISO8601Date']>;
  executionOrder: ExecutionOrder;
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  retailPrice: Scalars['BigInt'];
  status: Scalars['String'];
  totalPrice: Scalars['BigInt'];
  totalPriceBeforeVat: Scalars['BigInt'];
  typeACampaignId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['ISO8601DateTime'];
  variant: Variant;
  vatRetailPrice: Scalars['BigInt'];
  vatWholesalePrice: Scalars['BigInt'];
  wholesalePrice: Scalars['BigInt'];
};

export type ExtraDataFile = {
  createdAt: Scalars['ISO8601DateTime'];
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ForgotPasswordInput = {
  phoneNumber: Scalars['String'];
};

export type GenerateDispatchInfoInput = {
  orderId: Scalars['ID'];
};

export type GiftCampaign = {
  achievedPrizes?: Maybe<Array<OriginalPrize>>;
  applied: Scalars['Boolean'];
  bestDeal: Scalars['Boolean'];
  campaignName: Scalars['String'];
  canCheckOutRewards: Scalars['Int'];
  canDisplay?: Maybe<Scalars['Boolean']>;
  checkedOutRewards: Scalars['Int'];
  conditionCount: Scalars['Int'];
  confirmedData?: Maybe<GiftCampaignProgress>;
  confirmedProgressData?: Maybe<Array<GiftCampaignProgressItem>>;
  description: Scalars['String'];
  discount?: Maybe<Scalars['Float']>;
  duplicatedFrom?: Maybe<Scalars['ID']>;
  fromDate: Scalars['ISO8601Date'];
  giftInvoiceType?: Maybe<Scalars['Int']>;
  giftSelectionsOutOfQuantity?: Maybe<Array<Scalars['Int']>>;
  gifts: Array<GiftSelection>;
  hide: Scalars['Boolean'];
  holdOnReason?: Maybe<Scalars['String']>;
  holdOnUntil?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  importableSameOrder: Scalars['Boolean'];
  isSpin?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  multiplyBy: Scalars['Int'];
  multiplyByTypeB?: Maybe<Scalars['Int']>;
  noncombinable: Scalars['Boolean'];
  noncombinableParentId?: Maybe<Scalars['ID']>;
  parentId?: Maybe<Scalars['ID']>;
  progressData?: Maybe<Array<GiftCampaignProgressItem>>;
  progressDataWithoutCart?: Maybe<Array<GiftCampaignProgressItem>>;
  remainingRewardTimes: Scalars['Int'];
  remainingRewardTimesInCart?: Maybe<Scalars['Int']>;
  remainingTurns?: Maybe<Scalars['Int']>;
  requirements: Array<VariantGiftCondition>;
  selectableQuantity: Scalars['Int'];
  selectedGift?: Maybe<SelectedGift>;
  selectedGifts?: Maybe<Array<SelectedGift>>;
  selectedGiftsInCart?: Maybe<Array<SelectedGift>>;
  selectedGiftsTypeBInWarehouse?: Maybe<Array<SelectedGift>>;
  toDate: Scalars['ISO8601Date'];
  totalConfirmedRewards: Scalars['Int'];
  totalRewards?: Maybe<Scalars['Float']>;
  totalRewardsInCart?: Maybe<Scalars['Int']>;
  totalRewardsWithCart: Scalars['Int'];
  totalRewardsWithoutCart?: Maybe<Scalars['Int']>;
  totalTurns?: Maybe<Scalars['Int']>;
  totalUnconfirmedRewards: Scalars['Int'];
  type: Scalars['String'];
  typeDescription: Scalars['String'];
  unconfirmedRewardTimesInCart?: Maybe<Scalars['Int']>;
};

/** The connection type for GiftCampaign. */
export type GiftCampaignConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GiftCampaignEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GiftCampaign>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type GiftCampaignEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GiftCampaign>;
};

export type GiftCampaignProgress = {
  confirmedQuantity?: Maybe<Scalars['Int']>;
  confirmedRevenue?: Maybe<Scalars['BigInt']>;
  confirmedRewards?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  totalQuantity?: Maybe<Scalars['Int']>;
  totalRevenue?: Maybe<Scalars['BigInt']>;
  totalRewards?: Maybe<Scalars['Int']>;
  unconfirmedQuantity?: Maybe<Scalars['Int']>;
  unconfirmedRevenue?: Maybe<Scalars['BigInt']>;
};

export type GiftCampaignProgressItem = {
  confirmedQuantity: Scalars['Int'];
  confirmedRevenue: Scalars['BigInt'];
  id: Scalars['ID'];
  materialNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: Scalars['Int'];
  revenue: Scalars['BigInt'];
};

export type GiftConditionItem = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  propratedPrice?: Maybe<Scalars['BigInt']>;
  quantityThreshold?: Maybe<Scalars['Int']>;
  revenueThreshold?: Maybe<Scalars['BigInt']>;
  updatedAt: Scalars['ISO8601DateTime'];
  variant: Variant;
  variantId: Scalars['ID'];
  wholesalePrice: Scalars['BigInt'];
};

/** The connection type for GiftConditionItem. */
export type GiftConditionItemConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GiftConditionItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GiftConditionItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type GiftConditionItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GiftConditionItem>;
};

export type GiftSelection = {
  description?: Maybe<Scalars['String']>;
  giftSelectionItemGroups: Array<GiftSelectionItemGroup>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  selectableQuantity: Scalars['Int'];
};

export type GiftSelectionItem = {
  groupId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  occupiedQuantity?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  quantityInWarehouse?: Maybe<Scalars['Int']>;
  totalValue?: Maybe<Scalars['Int']>;
  variant: Variant;
};


export type GiftSelectionItemOccupiedQuantityArgs = {
  orderId?: InputMaybe<Scalars['ID']>;
};

export type GiftSelectionItemGroup = {
  giftSelectionItems: Array<GiftSelectionItem>;
  groupId: Scalars['ID'];
  itemCount: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type GroupedDiscount = {
  applicableDiscounts: Array<Discount>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type ImportInventoryTemplate = {
  url: Scalars['String'];
};

export type InventoryByVariant = {
  available?: Maybe<Scalars['Int']>;
  dateList: Array<Scalars['ISO8601Date']>;
  internalTransfer?: Maybe<Scalars['Int']>;
  lockedTimeTo?: Maybe<Scalars['ISO8601DateTime']>;
  neededQuantity: Scalars['Int'];
  orderId?: Maybe<Scalars['ID']>;
  totalStock?: Maybe<Scalars['Int']>;
  variant: Variant;
};

export type InventoryCheckHistory = {
  availableQuantity: Scalars['Int'];
  checkedQuantity: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  inventoryQuantity: Scalars['Int'];
  totalStock: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  variant: Variant;
};

export type ItemCategory = {
  codeItemCategory?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  giftItemCategory?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type LevelableGiftCampaign = {
  achievedPrizes?: Maybe<Array<OriginalPrize>>;
  applied: Scalars['Boolean'];
  bestDeal: Scalars['Boolean'];
  campaignName: Scalars['String'];
  canCheckOutRewards: Scalars['Int'];
  canDisplay?: Maybe<Scalars['Boolean']>;
  checkedOutRewards: Scalars['Int'];
  conditionCount: Scalars['Int'];
  confirmedData?: Maybe<GiftCampaignProgress>;
  confirmedProgressData?: Maybe<Array<GiftCampaignProgressItem>>;
  description: Scalars['String'];
  discount?: Maybe<Scalars['Float']>;
  duplicatedFrom?: Maybe<Scalars['ID']>;
  fromDate: Scalars['ISO8601Date'];
  giftCampaignChildren?: Maybe<Array<GiftCampaign>>;
  giftInvoiceType?: Maybe<Scalars['Int']>;
  giftSelectionsOutOfQuantity?: Maybe<Array<Scalars['Int']>>;
  gifts: Array<GiftSelection>;
  hide: Scalars['Boolean'];
  holdOnReason?: Maybe<Scalars['String']>;
  holdOnUntil?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  importableSameOrder: Scalars['Boolean'];
  isSpin?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  multiplyBy: Scalars['Int'];
  multiplyByTypeB?: Maybe<Scalars['Int']>;
  noncombinable: Scalars['Boolean'];
  noncombinableParentId?: Maybe<Scalars['ID']>;
  parentId?: Maybe<Scalars['ID']>;
  progressData?: Maybe<Array<GiftCampaignProgressItem>>;
  progressDataWithoutCart?: Maybe<Array<GiftCampaignProgressItem>>;
  remainingRewardTimes: Scalars['Int'];
  remainingRewardTimesInCart?: Maybe<Scalars['Int']>;
  remainingTurns?: Maybe<Scalars['Int']>;
  requirements: Array<VariantGiftCondition>;
  selectableQuantity: Scalars['Int'];
  selectedGift?: Maybe<SelectedGift>;
  selectedGifts?: Maybe<Array<SelectedGift>>;
  selectedGiftsInCart?: Maybe<Array<SelectedGift>>;
  selectedGiftsTypeBInWarehouse?: Maybe<Array<SelectedGift>>;
  toDate: Scalars['ISO8601Date'];
  totalConfirmedRewards: Scalars['Int'];
  totalRewards?: Maybe<Scalars['Float']>;
  totalRewardsInCart?: Maybe<Scalars['Int']>;
  totalRewardsWithCart: Scalars['Int'];
  totalRewardsWithoutCart?: Maybe<Scalars['Int']>;
  totalTurns?: Maybe<Scalars['Int']>;
  totalUnconfirmedRewards: Scalars['Int'];
  type: Scalars['String'];
  typeDescription: Scalars['String'];
  unconfirmedRewardTimesInCart?: Maybe<Scalars['Int']>;
};

export type ListBillings = {
  billings: SapBillingConnection;
  totalBillingAmount: Scalars['BigInt'];
};


export type ListBillingsBillingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ListNotification = {
  /** filter argument can be 'unread', 'read', '' == all */
  notifications: NotificationConnection;
  unreadCount: Scalars['Int'];
};


export type ListNotificationNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ListPaymentHistories = {
  paymentHistories: PaymentHistoryConnection;
  totalPaidAmount: Scalars['BigInt'];
  totalReturnedAmount: Scalars['BigInt'];
};


export type ListPaymentHistoriesPaymentHistoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type LoginInput = {
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type LuckyWheelPrize = {
  createdAt: Scalars['ISO8601DateTime'];
  currentQuantity: Scalars['Int'];
  customer?: Maybe<Customer>;
  id: Scalars['ID'];
  name: Scalars['String'];
  turn: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  variantGift: GiftCampaign;
};

/** The connection type for LuckyWheelPrize. */
export type LuckyWheelPrizeConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LuckyWheelPrizeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LuckyWheelPrize>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type LuckyWheelPrizeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LuckyWheelPrize>;
};

export type MaintainStatus = {
  /** Whether the maintain is active or not */
  maintain: Scalars['Boolean'];
  /** Message to display to the user!! This message can be EMPTY */
  message?: Maybe<Scalars['String']>;
};

export type MarkNotificationsAsReadInput = {
  readNotificationIds: Array<Scalars['ID']>;
};

export type MarkPopupBannerAsShownInput = {
  popupBannerId: Scalars['ID'];
};

export type Mutation = {
  /** Mutation for adding an item to a quotation */
  addItemToQuotation?: Maybe<QuotationItem>;
  /** Mutation for adding items to a shopping list */
  addToList?: Maybe<ShoppingList>;
  /** Mutation for allowing users to add permissions to a selected user */
  addUserPermission?: Maybe<UserPermission>;
  /** Mutation for applying a shopping list to a user's cart */
  applyListToCart?: Maybe<Order>;
  /** Mutation for generating child order items for a given order in a warehouse execution order */
  buildOrderItemsInWarehouse?: Maybe<Order>;
  /** Mutation for canceling an inventory check by removing all order items with the given variant IDs from the current cart */
  cancelInventoryCheck?: Maybe<Order>;
  /** Mutation for canceling an order with reasons */
  cancelOrder?: Maybe<Order>;
  /** Mutation for allowing users to change their password */
  changePassword?: Maybe<User>;
  /** Mutation for updating the status of a user */
  changeUserStatus?: Maybe<User>;
  /** Mutation for changing the type of a user (middle manager or member) */
  changeUserType?: Maybe<User>;
  /** Mutation for returning inventory information for list variants */
  checkInventoryByListVariants?: Maybe<CheckInventoryByListVariants>;
  /** Mutation to checkout an order */
  checkout?: Maybe<Order>;
  /** Mutation for checking out gifts in an order */
  checkoutGift?: Maybe<Order>;
  /** Mutation to checkout an order with the internal dispatch feature */
  checkoutWithInternalDispatch?: Maybe<Array<Order>>;
  /** Mutation for creating a user password */
  createPassword?: Maybe<User>;
  /** Mutation for creating a new quotation */
  createQuotation?: Maybe<Quotation>;
  /** Mutation for creating a new Servey Customer */
  createServeyCustomer?: Maybe<ServeyCustomer>;
  /** Mutation for creating a shipping address for the current user */
  createShippingAddress?: Maybe<Address>;
  /** Mutation for creating a new shopping list for the current user's customer with the given name */
  createShoppingList?: Maybe<ShoppingList>;
  /** Mutation for creating a new user */
  createUser?: Maybe<User>;
  /** Mutation for deleting shopping list items from a shopping list */
  deleteItemsInList?: Maybe<ShoppingList>;
  /** Mutation for deleting selected gifts that belong to a specific customer */
  deleteSelectedGifts?: Maybe<Array<SelectedGift>>;
  /** Mutation for deleting one or more shopping lists belonging to the current user's customer account */
  deleteShoppingLists?: Maybe<Array<ShoppingList>>;
  /** Delete warranty order by id */
  deleteWarrantyOrder?: Maybe<DeleteWarrantyOrderMutationPayload>;
  /** Delete warranty order item */
  deleteWarrantyOrderItem?: Maybe<DeleteWarrantyOrderItemMutationPayload>;
  /** Mutation for sending a password reset SMS message to a user's phone number */
  forgotPassword?: Maybe<User>;
  /** Mutation for generating execution orders and eta info */
  generateDispatchInfo?: Maybe<Order>;
  /** Mutation for logging in a user */
  login?: Maybe<Authentication>;
  /** Mutation to mark all notifications of a user as read */
  markAllNotificationsAsRead?: Maybe<Scalars['JSON']>;
  /** Mutation for marking specific notifications as read for the authenticated user */
  markNotificationsAsRead?: Maybe<Scalars['JSON']>;
  /** Mutation for marking a popup banner as shown */
  markPopupBannerAsShown?: Maybe<Scalars['JSON']>;
  /** Mutation for registering a user, where the user is identified by their phone number */
  register?: Maybe<User>;
  /** Mutation for removing level 2 order */
  removeLevel2Order?: Maybe<RemoveLevel2OrderMutationPayload>;
  /** Mutation for removing one or more order items from the current cart of the authenticated user */
  removeOrderItems?: Maybe<Order>;
  /** Mutation for removing all Type B gifts from a specific order in the warehouse */
  removeSelectedGiftsTypeBInWarehouse?: Maybe<RemoveSelectedGiftsTypeBInWarehousePayload>;
  /** Mutation for removing a user from the system */
  removeUser?: Maybe<RemoveUserMutationPayload>;
  /** Mutation for removing a permission of a user */
  removeUserPermission?: Maybe<RemoveUserPermissionMutationPayload>;
  /** Mutation for allowing users to reorder a previous order */
  reorder?: Maybe<Order>;
  /** Mutation for resending an OTP (one-time password) for user verification */
  resendOtp?: Maybe<User>;
  /** Mutation for resetting a user's password */
  resetPassword?: Maybe<User>;
  /** Save level 2 customer order */
  saveLevel2CustomerOrder?: Maybe<Order>;
  /** Mutation for saving a product to the user's saved products list */
  saveProduct?: Maybe<Product>;
  /** Mutation for updating a Searchjoy::Search object with conversion data */
  searchConversion?: Maybe<Scalars['JSON']>;
  /** Mutation for selecting a gift */
  selectGift?: Maybe<SelectedGift>;
  /** Mutation for handling the selection of gift items in a gift campaign */
  selectGiftItem?: Maybe<SelectedGiftItem>;
  /** Mutation for Selecting items from cart and add to selected cart */
  selectItemsFromCart?: Maybe<Order>;
  /** Mutation for send the invoice to the customer */
  sendInvoice?: Maybe<Scalars['JSON']>;
  /** Mutation for spinning the lucky wheel which would return a prize */
  spinLuckyWheel?: Maybe<LuckyWheelPrize>;
  /** Mutation to unsave a product from a user's saved products list */
  unsaveProduct?: Maybe<Product>;
  /** Mutation for updating a branch object */
  updateBranch?: Maybe<Branch>;
  /** Mutation for updating the quantity of a specific product variant in the current user's cart */
  updateCart?: Maybe<Order>;
  /** Mutation for updating the status of one or more execution order items in a cart */
  updateExecutionOrderItem?: Maybe<Array<ExecutionOrder>>;
  /** Mutation for updating the quantity of an order item */
  updateOrderItem?: Maybe<OrderItem>;
  /** Mutation for updating a quotation */
  updateQuotation?: Maybe<Quotation>;
  updateQuotationOrder: Scalars['Boolean'];
  /** Mutation for updating a servey customer */
  updateServeyCustomer?: Maybe<ServeyCustomer>;
  /** Create new and update warranty order */
  updateWarrantyOrder?: Maybe<WarrantyOrder>;
  /** Create new warranty order item when there is non or Update warranty order item when there is one */
  updateWarrantyOrderItem?: Maybe<WarrantyOrderItem>;
  /** Mutation for verifying the phone number during the login flow */
  verifyPhoneLogin?: Maybe<Authentication>;
  /** Mutation for verifying a phone number during the registration flow */
  verifyPhoneRegistration?: Maybe<User>;
  /** Mutation for allowing a user to create or update a web push notification token associated with their account */
  webpushTokens?: Maybe<Scalars['JSON']>;
};


export type MutationAddItemToQuotationArgs = {
  input: AddItemToQuotationInput;
};


export type MutationAddToListArgs = {
  input: AddToListInput;
};


export type MutationAddUserPermissionArgs = {
  input: AddUserPermissionInput;
};


export type MutationApplyListToCartArgs = {
  input: ApplyListToCartInput;
};


export type MutationBuildOrderItemsInWarehouseArgs = {
  input: BuildOrderItemsInWarehouseInput;
};


export type MutationCancelInventoryCheckArgs = {
  input: CancelInventoryCheckInput;
};


export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChangeUserStatusArgs = {
  input: ChangeUserStatusInput;
};


export type MutationChangeUserTypeArgs = {
  input: ChangeUserTypeInput;
};


export type MutationCheckInventoryByListVariantsArgs = {
  input: CheckInventoryByListVariantsInput;
};


export type MutationCheckoutArgs = {
  input: CheckoutInput;
};


export type MutationCheckoutGiftArgs = {
  input: CheckoutGiftInput;
};


export type MutationCheckoutWithInternalDispatchArgs = {
  input: DispatchCheckoutInput;
};


export type MutationCreatePasswordArgs = {
  input: CreatePasswordInput;
};


export type MutationCreateQuotationArgs = {
  input: CreateQuotationInput;
};


export type MutationCreateServeyCustomerArgs = {
  input: CreateServeyCustomerInput;
};


export type MutationCreateShippingAddressArgs = {
  input: CreateShippingAddressInput;
};


export type MutationCreateShoppingListArgs = {
  input: ShoppingListInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteItemsInListArgs = {
  input: DeleteItemsInListInput;
};


export type MutationDeleteSelectedGiftsArgs = {
  input: DeleteSelectedGiftsInput;
};


export type MutationDeleteShoppingListsArgs = {
  input: DeleteShoppingListsInput;
};


export type MutationDeleteWarrantyOrderArgs = {
  input: DeleteWarrantyOrderInput;
};


export type MutationDeleteWarrantyOrderItemArgs = {
  input: DeleteWarrantyOrderItemInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationGenerateDispatchInfoArgs = {
  input: GenerateDispatchInfoInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMarkAllNotificationsAsReadArgs = {
  input: EmptyInput;
};


export type MutationMarkNotificationsAsReadArgs = {
  input: MarkNotificationsAsReadInput;
};


export type MutationMarkPopupBannerAsShownArgs = {
  input: MarkPopupBannerAsShownInput;
};


export type MutationRegisterArgs = {
  input: RegistrationInput;
};


export type MutationRemoveLevel2OrderArgs = {
  input: RemoveLevel2OrderInput;
};


export type MutationRemoveOrderItemsArgs = {
  input: RemoveOrderItemsInput;
};


export type MutationRemoveSelectedGiftsTypeBInWarehouseArgs = {
  input: RemoveSelectGiftsTypeBInWarehouseInput;
};


export type MutationRemoveUserArgs = {
  input: RemoveUserInput;
};


export type MutationRemoveUserPermissionArgs = {
  input: RemoveUserPermissionInput;
};


export type MutationReorderArgs = {
  input: ReorderInput;
};


export type MutationResendOtpArgs = {
  input: ResendOtpInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSaveLevel2CustomerOrderArgs = {
  input: SaveLevel2CustomerOrderInput;
};


export type MutationSaveProductArgs = {
  input: SaveProductInput;
};


export type MutationSearchConversionArgs = {
  input: SearchConversionInput;
};


export type MutationSelectGiftArgs = {
  input: SelectGiftInput;
};


export type MutationSelectGiftItemArgs = {
  input: SelectGiftItemInput;
};


export type MutationSelectItemsFromCartArgs = {
  input: SelectItemsFromCartInput;
};


export type MutationSendInvoiceArgs = {
  input: SendInvoiceInput;
};


export type MutationSpinLuckyWheelArgs = {
  input: SpinLuckyWheelInput;
};


export type MutationUnsaveProductArgs = {
  input: UnsaveProductInput;
};


export type MutationUpdateBranchArgs = {
  input: UpdateBranchInput;
};


export type MutationUpdateCartArgs = {
  input: UpdateCartInput;
};


export type MutationUpdateExecutionOrderItemArgs = {
  input: UpdateExecutionOrderItemInput;
};


export type MutationUpdateOrderItemArgs = {
  input: UpdateOrderItemInput;
};


export type MutationUpdateQuotationArgs = {
  input: UpdateQuotationInput;
  isSurveyCustomer: Scalars['Boolean'];
};


export type MutationUpdateServeyCustomerArgs = {
  input: UpdateServeyCustomerInput;
};


export type MutationUpdateWarrantyOrderArgs = {
  input?: InputMaybe<WarrantyOrderInput>;
};


export type MutationUpdateWarrantyOrderItemArgs = {
  input: WarrantyOrderItemInput;
};


export type MutationVerifyPhoneLoginArgs = {
  input: VerifyPhoneNumberInput;
};


export type MutationVerifyPhoneRegistrationArgs = {
  input: VerifyPhoneNumberInput;
};


export type MutationWebpushTokensArgs = {
  input: WebpushTokenInput;
};

export type NoncombinableGiftCampaign = {
  giftCampaignGroups?: Maybe<Array<GiftCampaign>>;
  groupId: Scalars['ID'];
};

export type Notification = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  message: Scalars['String'];
  params: Scalars['JSON'];
  readAt?: Maybe<Scalars['ISO8601DateTime']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

/** The connection type for Notification. */
export type NotificationConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Notification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type NotificationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Notification>;
};

export type OptionType = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  optionValues: Array<OptionValue>;
  optionValuesByCategory: Array<OptionValue>;
  optionValuesByProduct: Array<OptionValue>;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type OptionTypeOptionValuesByCategoryArgs = {
  categoryId: Scalars['ID'];
};


export type OptionTypeOptionValuesByProductArgs = {
  productId: Scalars['ID'];
};

export type OptionValue = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  optionType: OptionType;
  updatedAt: Scalars['ISO8601DateTime'];
  value: Scalars['String'];
};

export type Order = {
  buyer?: Maybe<Customer>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']>;
  checkedOutAt?: Maybe<Scalars['ISO8601DateTime']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  customer: Customer;
  dispatchedAt?: Maybe<Scalars['ISO8601DateTime']>;
  dispatchedStatus?: Maybe<Array<Scalars['String']>>;
  eoTotal?: Maybe<Scalars['BigInt']>;
  eoTotalQuantity?: Maybe<Scalars['Int']>;
  estimateDeliveredAt?: Maybe<Scalars['ISO8601DateTime']>;
  eta?: Maybe<Scalars['ISO8601Date']>;
  fromExportGift?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoiceNumbers: Array<Scalars['String']>;
  isReturn: Scalars['Boolean'];
  itemCount: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  orderGifts?: Maybe<OrderGiftConnection>;
  orderItems?: Maybe<OrderItemConnection>;
  orderType?: Maybe<Scalars['String']>;
  returnedGifts?: Maybe<ReturnedGiftConnection>;
  returnedItems?: Maybe<ReturnedItemConnection>;
  salesOrg: SalesOrg;
  sapId?: Maybe<Scalars['ID']>;
  seller?: Maybe<Customer>;
  shippingAddress?: Maybe<Address>;
  slocAddress?: Maybe<Sloc>;
  status: Scalars['String'];
  total: Scalars['BigInt'];
  totalQuantity: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  userCheckout?: Maybe<User>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};


export type OrderOrderGiftsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderOrderItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  timeOrder?: InputMaybe<Scalars['String']>;
  vatRatio?: InputMaybe<Scalars['Float']>;
};


export type OrderReturnedGiftsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrderReturnedItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Order. */
export type OrderConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type OrderEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

export type OrderGift = {
  createdAt: Scalars['ISO8601DateTime'];
  giftInvoiceType?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  order: Order;
  price: Scalars['BigInt'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  variant: Variant;
};

/** The connection type for OrderGift. */
export type OrderGiftConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderGiftEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OrderGift>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type OrderGiftEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<OrderGift>;
};

export type OrderItem = {
  adjustmentTotal: Scalars['Float'];
  anyImportableSameOrder: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  discounts: Array<DiscountDetails>;
  giftCampaigns?: Maybe<Array<GiftCampaign>>;
  hasAllGiftsSelected: Scalars['Boolean'];
  id: Scalars['ID'];
  levelableGiftCampaigns?: Maybe<Array<LevelableGiftCampaign>>;
  noncombinableGiftCampaigns?: Maybe<Array<NoncombinableGiftCampaign>>;
  order: Order;
  ownCampaignTypeA: Scalars['Boolean'];
  price: Scalars['BigInt'];
  quantity: Scalars['Int'];
  retailPrice: Scalars['BigInt'];
  totalPrice: Scalars['BigInt'];
  totalPriceBeforeVat: Scalars['BigInt'];
  updatedAt: Scalars['ISO8601DateTime'];
  userCreator?: Maybe<User>;
  userUpdater?: Maybe<User>;
  variant: Variant;
  vat: Scalars['BigInt'];
  vatPercent: Scalars['Float'];
  vatRetailPrice: Scalars['BigInt'];
  vatWholesalePrice: Scalars['BigInt'];
  wholesalePrice: Scalars['BigInt'];
};

/** The connection type for OrderItem. */
export type OrderItemConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OrderItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type OrderItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<OrderItem>;
};

export type OrderItemVat = {
  amount: Scalars['Float'];
  count: Scalars['Int'];
  name: Scalars['String'];
};

export type OriginalPrize = {
  achievedQuantity: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  nameDetail: Scalars['String'];
  originalProbability: Scalars['Float'];
  originalQuantity: Scalars['Int'];
  probability: Scalars['Float'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  variantGift: GiftCampaign;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PaymentHistory = {
  amount: Scalars['BigInt'];
  documentDate: Scalars['ISO8601Date'];
  documentNumber: Scalars['String'];
  documentType: Scalars['String'];
};

/** The connection type for PaymentHistory. */
export type PaymentHistoryConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentHistoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PaymentHistory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PaymentHistoryEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PaymentHistory>;
};

export type Product = {
  baseUnit: Unit;
  brand?: Maybe<Brand>;
  categories?: Maybe<Array<Category>>;
  createdAt: Scalars['ISO8601DateTime'];
  defaultVariant?: Maybe<Variant>;
  filterVariant?: Maybe<Variant>;
  id: Scalars['ID'];
  isSaved?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  optionTypes: Array<OptionType>;
  promotedVariant?: Maybe<Variant>;
  updatedAt: Scalars['ISO8601DateTime'];
  variants: Array<Variant>;
};


export type ProductDefaultVariantArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']>;
};


export type ProductFilterVariantArgs = {
  attributes?: InputMaybe<Array<Scalars['String']>>;
  priceGte?: InputMaybe<Scalars['Int']>;
  priceLte?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Product. */
export type ProductConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Product>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProductEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Product>;
};

export type Query = {
  /**
   * Return a list of gift campaigns for an user,
   *       filtered by those currently in progress/or not in progress
   */
  allGiftCampaigns: GiftCampaignConnection;
  /** Return list of products that are on sale */
  allPromotedProducts: ProductConnection;
  /**
   * Return a list of non-combinable gift campaigns within the same group,
   *       based on the increase in revenue or order item quality.
   */
  allSameGroupNcCampaigns: GiftCampaignConnection;
  /** Return  a list of applied variants based on the discount program, discount type, and discount value */
  appliedVariantsDiscount: VariantConnection;
  /** Return list of banner */
  banners: Array<Banner>;
  /** Get bonus sale details */
  bonusSale: BonusSale;
  /** Return a list of bonus sales */
  bonusSales: Array<BonusSale>;
  /** Return details of a gift campaign with respect to the provided order */
  campaignDetailsByOrder: GiftCampaign;
  /** return gift campaigns details based on particular campaign Ids */
  campaigns: Array<GiftCampaign>;
  /** Return cart data for the current user */
  cart: Order;
  /** list all gift campaigns applied to the current cart */
  cartGiftCampaigns: Array<GiftCampaign>;
  /** Return the top level product categories */
  categories: Array<Category>;
  /** Return a specific product category */
  category: Category;
  /** Return a list of grouped discount lists with identical structure/definition within a specific category */
  categoryDiscounts: Array<CategoryDiscount>;
  /** Return a list of gift campaigns for a particular category */
  categoryGiftCampaigns: GiftCampaignConnection;
  /** Return a list of condition items for a particular gift condition */
  conditionItems: GiftConditionItemConnection;
  /** Return the balance for the current customer */
  currentBalance?: Maybe<Balance>;
  /** Return customer details */
  customer: Customer;
  /** Return a list of customers for a specific sales org */
  customers: Array<Customer>;
  /** Return a list of channels */
  distributionChannels: Array<DistributionChannel>;
  /** Return estimated time of arrival for the items in a specific order */
  estimateTimeArrival: EstimateTimeArrival;
  /** Calculate the execution orders for a purchased/given order */
  executionOrders: Array<ExecutionOrder>;
  /** Return ID of unshown banner for expiring promotions */
  expiringPromotionsBanner?: Maybe<Scalars['ID']>;
  /** Return a list of feature flags by consuming a list of key names */
  featureFlags?: Maybe<Array<AppConfiguration>>;
  /** return the details for a specific shopping list */
  fetchListItems: ShoppingList;
  /** Return first spin campaign for lucky wheel. */
  firstSpinCampaign?: Maybe<GiftCampaign>;
  /** Return all Campaign Groups for gift campaigns of type B (Loyalty Program), based on item category. */
  getCampaignGroups: Array<ItemCategory>;
  /** return all shopping lists for the current customer */
  getLists: ShoppingListConnection;
  /** Return all Category's option types */
  getOptionTypes: Array<OptionType>;
  /** Details of a particular gift campaign */
  giftCampaignDetails: GiftCampaign;
  /** Return a list of orders that are associated with the gift campaign (applicable only for type B) */
  giftCampaignOrders: OrderConnection;
  /** Return a list of grouped discount lists with identical structure/definition */
  groupedDiscounts: Array<GroupedDiscount>;
  /** Return the template url for importing the inventory check */
  importCheckInventoryTemplate: ImportInventoryTemplate;
  /** Return inventory of all gift selection items */
  inventoryByGiftSelection: GiftSelection;
  /** Return inventory information for a specific variant */
  inventoryByVariant?: Maybe<InventoryByVariant>;
  /** Return inventory information for a specific variant */
  inventoryCheck?: Maybe<InventoryByVariant>;
  inventoryCheckHistory?: Maybe<Array<InventoryCheckHistory>>;
  /** Return the invoice url for a specific billing */
  invoice: SapBilling;
  /** List all orders that bought by level 2 customers */
  level2Orders: OrderConnection;
  /** List all billings of the current customer */
  listBillings: ListBillings;
  /** Return all available brands of system */
  listBrand: Array<Brand>;
  /** Return all available colors of system */
  listColor: Array<OptionValue>;
  /** Return list of execution orders for a purchased/given order */
  listExecutionOrders: Array<ExecutionOrder>;
  /** Return notifications of current users */
  listNotifications: ListNotification;
  /** Return all option values for a specific Option Type within the same category */
  listOptionValues: Array<OptionValue>;
  /** List all payment histories of the current customer */
  listPaymentHistories: ListPaymentHistories;
  /** Return all lucky wheel history of a user */
  luckyWheelHistory: LuckyWheelPrizeConnection;
  /** Return orinal prizes list in a campaign(mutable) */
  luckyWheelPrizes: Array<OriginalPrize>;
  /** Return maintain status */
  maintainStatus: MaintainStatus;
  /** Return list of noncombinable gift campaigns in the same group with respect to an order */
  ncCampaignsByGroupInOrder: GiftCampaignConnection;
  /** Return notifications from current user with ids */
  notifications: Array<Notification>;
  /** Return data for a particular order by id */
  order: Order;
  /** Return order item by id */
  orderItem: OrderItem;
  /** Return a list of discount details by order item id */
  orderItemDiscounts?: Maybe<Array<DiscountDetails>>;
  /** Return a list of order item vat */
  orderItemsVats?: Maybe<Array<OrderItemVat>>;
  /** Return a list of condition items ordered by the quantity purchased */
  orderedConditionItems: GiftConditionItemConnection;
  /** List all orders of the current user, with optional search/sort query */
  orders: OrderConnection;
  /** Returns a list of permissions for a user */
  permissionsForUser: Array<UserPermission>;
  /** Returns a list of products purchased within 90 days ago in sales org */
  popularProducts: ProductConnection;
  /** Return a specific product by id */
  product: Product;
  /** Return a specific product by passing variant's material number */
  productByMaterialNumber: Product;
  /** Return a list of promotions for a particular product */
  productPromotions?: Maybe<Array<GiftCampaign>>;
  /**
   * Return  a list of type B(or C) gift campaigns that are currently in
   *       progress and whose progress is not counted in the cart.
   */
  progressGiftCampaigns: GiftCampaignConnection;
  /** Return first 10 products that are on sale */
  promotedProducts: Array<Product>;
  /** Return list variants as gifts */
  quotationGifts: Array<GiftCampaign>;
  /** Returns a list of favorite products or purchased within 90 days ago */
  recommendedProducts: ProductConnection;
  /** List all products related to the current variant */
  relatedProducts: ProductConnection;
  /** Return sales employee details */
  salesEmployee: SalesEmployee;
  /** Return list sales employees in specific sales org */
  salesEmployees: Array<SalesEmployee>;
  /** Return the details for a specific sales org */
  salesOrgDetails: SalesOrg;
  /** Return details for all sales orgs */
  salesOrgs: Array<SalesOrg>;
  /** Return the current user's saved products */
  savedProducts: ProductConnection;
  /** Return selected cart data for the current user */
  selectedCart: Order;
  /**
   * Return list of type B selected gifts in warehouse for a specific order when its campaign is
   *      still in effect, when the campaign is over, the selected gift will be removed
   */
  selectedGiftsTypeBInWarehouse: Array<SelectedGift>;
  /** return servey customer details */
  serveyCustomer: ServeyCustomer;
  /** Return a list of servery customers */
  serveyCustomers: Array<ServeyCustomer>;
  /** Return all shipping addresses of the current user's customer */
  shippingAddresses?: Maybe<Array<Address>>;
  /** List all products of the same categories as the input product */
  similarProducts: ProductConnection;
  /** Return all sloc addresses of sales org of the current user's customer */
  slocAddresses?: Maybe<Array<Sloc>>;
  /** Return a list of prizes that the customer get for lucky wheel campaign */
  spinCampaigns?: Maybe<GiftCampaignConnection>;
  trip: TmsTrip;
  /** Return a list of trips for a specific order */
  trips: Array<TmsTrip>;
  /** Return a list of type A gift campaigns in the cart */
  typeACartGiftCampaigns: Array<GiftCampaign>;
  /** Get user's information */
  userProfile?: Maybe<User>;
  /** Return all users of the current customer */
  users: Array<User>;
  /** Return a Product's variant matching the chosen option values */
  variant?: Maybe<Variant>;
  /** Return the variant with the chosen ID */
  variantById?: Maybe<Variant>;
  /** Return a product's variant matching the chosen option values */
  variantByOptionValues?: Maybe<Variant>;
  /** Return a list of gift campaigns for a particular variant */
  variantCampaigns: Array<GiftCampaign>;
  /** Return variant details */
  variantDetails: Variant;
  /** List all variants whose name, category, or brand match the query */
  variantSearch: VariantSearch;
  /** list all type b(Loyalty Program) gift campaigns applied to the order that items is available in warehouse */
  warehouseTypeBCampaigns: Array<GiftCampaign>;
  /** return the list of warranty histories for a customer */
  warrantyInformation: WarrantyInformation;
  /** Return detail of one warranty order by its id */
  warrantyOrder: WarrantyOrder;
  /** Return a list of warranty orders for the current user */
  warrantyOrders: WarrantyOrderConnection;
};


export type QueryAllGiftCampaignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  inProgress: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllPromotedProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllSameGroupNcCampaignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAppliedVariantsDiscountArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  discountProgramId: Scalars['ID'];
  discountType?: InputMaybe<Scalars['String']>;
  discountValue: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryBonusSaleArgs = {
  id: Scalars['ID'];
};


export type QueryBonusSalesArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryCampaignDetailsByOrderArgs = {
  campaignId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryCampaignsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryCartArgs = {
  isLevel2?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCartGiftCampaignsArgs = {
  filter?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryCategoryDiscountsArgs = {
  categoryId: Scalars['ID'];
  discountProgramId?: InputMaybe<Scalars['ID']>;
};


export type QueryCategoryGiftCampaignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryConditionItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryCustomersArgs = {
  channel?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  salesOrgId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryEstimateTimeArrivalArgs = {
  orderId: Scalars['ID'];
};


export type QueryExecutionOrdersArgs = {
  orderId: Scalars['ID'];
};


export type QueryFeatureFlagsArgs = {
  keyNames: Array<Scalars['String']>;
};


export type QueryFetchListItemsArgs = {
  listId: Scalars['ID'];
};


export type QueryGetListsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryGetOptionTypesArgs = {
  id: Scalars['ID'];
};


export type QueryGiftCampaignDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryGiftCampaignOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryInventoryByGiftSelectionArgs = {
  giftSelectionId: Scalars['ID'];
};


export type QueryInventoryByVariantArgs = {
  count?: InputMaybe<Scalars['Boolean']>;
  quantity: Scalars['Int'];
  variantId: Scalars['ID'];
};


export type QueryInventoryCheckArgs = {
  count?: InputMaybe<Scalars['Boolean']>;
  quantity: Scalars['Int'];
  variantId: Scalars['ID'];
};


export type QueryInvoiceArgs = {
  sapBillingId: Scalars['ID'];
};


export type QueryLevel2OrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryListBillingsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  fiStatus?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryListExecutionOrdersArgs = {
  orderId: Scalars['ID'];
};


export type QueryListOptionValuesArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type QueryListPaymentHistoriesArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryLuckyWheelHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryLuckyWheelPrizesArgs = {
  campaignId: Scalars['ID'];
};


export type QueryNcCampaignsByGroupInOrderArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderId: Scalars['ID'];
};


export type QueryNotificationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryOrderArgs = {
  id: Scalars['ID'];
};


export type QueryOrderItemArgs = {
  id: Scalars['ID'];
};


export type QueryOrderItemDiscountsArgs = {
  orderItemId: Scalars['ID'];
};


export type QueryOrderItemsVatsArgs = {
  orderId: Scalars['ID'];
};


export type QueryOrderedConditionItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  keyword?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  variantIds: Array<Scalars['ID']>;
};


export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  sapId?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryPermissionsForUserArgs = {
  selectedUserId: Scalars['ID'];
};


export type QueryPopularProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryProductArgs = {
  id: Scalars['ID'];
};


export type QueryProductByMaterialNumberArgs = {
  materialNumber: Scalars['String'];
};


export type QueryProductPromotionsArgs = {
  productId: Scalars['ID'];
};


export type QueryProgressGiftCampaignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  campaignType?: InputMaybe<Scalars['String']>;
  codeItemCategory?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  validDate?: InputMaybe<Scalars['Boolean']>;
};


export type QueryQuotationGiftsArgs = {
  campaignIds: Array<Scalars['ID']>;
};


export type QueryRecommendedProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryRelatedProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  variantId: Scalars['ID'];
};


export type QuerySalesEmployeeArgs = {
  id: Scalars['ID'];
};


export type QuerySalesEmployeesArgs = {
  salesOrgId: Scalars['ID'];
};


export type QuerySalesOrgDetailsArgs = {
  id: Scalars['ID'];
};


export type QuerySavedProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySelectedGiftsTypeBInWarehouseArgs = {
  orderId: Scalars['ID'];
};


export type QueryServeyCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryServeyCustomersArgs = {
  salesOrgId: Scalars['ID'];
};


export type QuerySimilarProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  productId: Scalars['ID'];
};


export type QuerySpinCampaignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryTripArgs = {
  id: Scalars['ID'];
};


export type QueryTripsArgs = {
  orderId: Scalars['ID'];
};


export type QueryVariantArgs = {
  optionValueIds: Array<Scalars['ID']>;
  productId: Scalars['ID'];
};


export type QueryVariantByIdArgs = {
  id: Scalars['ID'];
};


export type QueryVariantByOptionValuesArgs = {
  newOptionValueId?: InputMaybe<Scalars['ID']>;
  optionValueIds?: InputMaybe<Array<Scalars['ID']>>;
  productId: Scalars['ID'];
  variantId?: InputMaybe<Scalars['ID']>;
};


export type QueryVariantCampaignsArgs = {
  variantId: Scalars['ID'];
};


export type QueryVariantDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryVariantSearchArgs = {
  attributes?: InputMaybe<Array<Scalars['String']>>;
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  isServeyCustomer?: InputMaybe<Scalars['Boolean']>;
  optionValueIds?: InputMaybe<Array<Scalars['ID']>>;
  priceGte?: InputMaybe<Scalars['Int']>;
  priceLte?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryWarehouseTypeBCampaignsArgs = {
  filter?: InputMaybe<Scalars['Boolean']>;
};


export type QueryWarrantyInformationArgs = {
  customerSapId: Scalars['String'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryWarrantyOrderArgs = {
  id: Scalars['ID'];
};


export type QueryWarrantyOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type Quotation = {
  createdAt: Scalars['ISO8601DateTime'];
  customer?: Maybe<Customer>;
  date: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  quotationCode: Scalars['String'];
  quotationItems?: Maybe<QuotationItemConnection>;
  salesEmployee: SalesEmployee;
  salesOrg: SalesOrg;
  serveyCustomer?: Maybe<ServeyCustomer>;
  total?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type QuotationQuotationItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QuotationItem = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  isGift: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  quantity: Scalars['Int'];
  quotationId: Scalars['ID'];
  totalPrice?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  variant: Variant;
  vatPrice?: Maybe<Scalars['Int']>;
  vatWholeSalePrice?: Maybe<Scalars['Int']>;
};

/** The connection type for QuotationItem. */
export type QuotationItemConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<QuotationItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<QuotationItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type QuotationItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<QuotationItem>;
};

export type RegistrationInput = {
  phoneNumber: Scalars['String'];
};

export type RemoveLevel2OrderInput = {
  orderId: Scalars['ID'];
};

/** Autogenerated return type of RemoveLevel2OrderMutation */
export type RemoveLevel2OrderMutationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type RemoveOrderItemsInput = {
  deleteAll?: InputMaybe<Scalars['Boolean']>;
  orderItemIds: Array<Scalars['ID']>;
};

export type RemoveSelectGiftsTypeBInWarehouseInput = {
  orderId: Scalars['ID'];
};

/** Autogenerated return type of RemoveSelectedGiftsTypeBInWarehouse */
export type RemoveSelectedGiftsTypeBInWarehousePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type RemoveUserInput = {
  selectedUserId: Scalars['ID'];
};

/** Autogenerated return type of RemoveUserMutation */
export type RemoveUserMutationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type RemoveUserPermissionInput = {
  userPermissionId: Scalars['ID'];
};

/** Autogenerated return type of RemoveUserPermissionMutation */
export type RemoveUserPermissionMutationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ReorderInput = {
  orderId: Scalars['ID'];
};

export type ResendOtpInput = {
  userId: Scalars['ID'];
};

export type ResetPasswordInput = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  resetPasswordToken: Scalars['String'];
  userId: Scalars['ID'];
};

export type ReturnedGift = {
  createdAt: Scalars['ISO8601DateTime'];
  giftInvoiceType?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  itemCategory: Scalars['String'];
  order: Order;
  original?: Maybe<OrderItem>;
  price: Scalars['BigInt'];
  progressRevertedAt?: Maybe<Scalars['ISO8601DateTime']>;
  progressUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  quantity: Scalars['Int'];
  retailPrice: Scalars['BigInt'];
  salesDeal: Scalars['String'];
  totalPrice: Scalars['BigInt'];
  updatedAt: Scalars['ISO8601DateTime'];
  variant: Variant;
  vat: Scalars['BigInt'];
  vatWholesalePrice: Scalars['BigInt'];
  wholesalePrice: Scalars['BigInt'];
};

/** The connection type for ReturnedGift. */
export type ReturnedGiftConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReturnedGiftEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ReturnedGift>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ReturnedGiftEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ReturnedGift>;
};

export type ReturnedItem = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  itemCategory: Scalars['String'];
  order: Order;
  original?: Maybe<OrderItem>;
  originalCheckoutTime?: Maybe<Scalars['ISO8601DateTime']>;
  price: Scalars['BigInt'];
  progressRevertedAt?: Maybe<Scalars['ISO8601DateTime']>;
  progressUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  quantity: Scalars['Int'];
  retailPrice: Scalars['BigInt'];
  totalPrice: Scalars['BigInt'];
  updatedAt: Scalars['ISO8601DateTime'];
  variant: Variant;
  vat: Scalars['BigInt'];
  vatWholesalePrice: Scalars['BigInt'];
  wholesalePrice: Scalars['BigInt'];
};

/** The connection type for ReturnedItem. */
export type ReturnedItemConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReturnedItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ReturnedItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ReturnedItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ReturnedItem>;
};

export type SalesEmployee = {
  createdAt: Scalars['ISO8601DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  role: Scalars['String'];
  sapId: Scalars['String'];
  sapName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SalesOrg = {
  bankAccount?: Maybe<BankAccount>;
  branch?: Maybe<Branch>;
  company: Company;
  customers: CustomerConnection;
  id: Scalars['ID'];
  name: Scalars['String'];
  sapCode?: Maybe<Scalars['String']>;
  warehouseAddress?: Maybe<Scalars['String']>;
};


export type SalesOrgCustomersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SapBilling = {
  billingDate: Scalars['ISO8601Date'];
  billingTypeSapCode: Scalars['String'];
  fiStatus?: Maybe<Scalars['String']>;
  invoiceNo: Scalars['String'];
  invoiceUrl?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  returnedAmount?: Maybe<Scalars['BigInt']>;
  sapBillingId: Scalars['String'];
  sapOdId: Scalars['String'];
  vatTotalValue?: Maybe<Scalars['BigInt']>;
};

/** The connection type for SapBilling. */
export type SapBillingConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SapBillingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SapBilling>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SapBillingEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SapBilling>;
};

export type SaveLevel2CustomerOrderInput = {
  note: Scalars['String'];
};

export type SaveProductInput = {
  productId: Scalars['ID'];
};

export type SearchConversionInput = {
  convertableId: Scalars['ID'];
  convertableType: Scalars['String'];
  searchId: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
};

export type SelectGiftInput = {
  bWithOrder?: InputMaybe<Scalars['Boolean']>;
  campaignPage?: InputMaybe<Scalars['Boolean']>;
  giftSelectionId: Scalars['ID'];
  multiplyBy: Scalars['Int'];
  orderId?: InputMaybe<Scalars['ID']>;
};

export type SelectGiftItemInput = {
  campaignPage?: InputMaybe<Scalars['Boolean']>;
  giftSelectionItemId: Scalars['ID'];
  orderId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  selectedGiftId: Scalars['ID'];
};

export type SelectItemsFromCartInput = {
  selectedOrderItemIds: Array<Scalars['ID']>;
};

export type SelectedGift = {
  createdAt: Scalars['ISO8601DateTime'];
  giftBillingOption: Scalars['String'];
  giftSelection: GiftSelection;
  id: Scalars['ID'];
  multiplyBy: Scalars['Int'];
  orderId?: Maybe<Scalars['ID']>;
  selectableQuantity?: Maybe<Scalars['Int']>;
  selectedGiftItems: Array<SelectedGiftItem>;
  status: Scalars['String'];
  toDate?: Maybe<Scalars['ISO8601Date']>;
  totalValue?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  userId?: Maybe<Scalars['ID']>;
  variantGiftId: Scalars['ID'];
};

export type SelectedGiftItem = {
  createdAt: Scalars['ISO8601DateTime'];
  giftSelectionItem: GiftSelectionItem;
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  quantityBilled: Scalars['Int'];
  selectedGift: SelectedGift;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SendInvoiceInput = {
  sapBillingId: Scalars['ID'];
};

export type ServeyCustomer = {
  address?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  salesOrg?: Maybe<SalesOrg>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ShoppingList = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['ID']>;
  shoppingListItems?: Maybe<ShoppingListItemConnection>;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type ShoppingListShoppingListItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for ShoppingList. */
export type ShoppingListConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShoppingListEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ShoppingList>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ShoppingListEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ShoppingList>;
};

export type ShoppingListInput = {
  name: Scalars['String'];
};

export type ShoppingListItem = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  shoppingList: ShoppingList;
  updatedAt: Scalars['ISO8601DateTime'];
  variant: Variant;
};

/** The connection type for ShoppingListItem. */
export type ShoppingListItemConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShoppingListItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ShoppingListItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ShoppingListItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ShoppingListItem>;
};

/** Autogenerated return type of ShowPopupBannerForExpiringPromotions */
export type ShowPopupBannerForExpiringPromotionsPayload = {
  popupBannerId?: Maybe<Scalars['ID']>;
};

export type Sloc = {
  address?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  sapCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SpinLuckyWheelInput = {
  campaignId: Scalars['ID'];
};

export type Subscription = {
  newUserNotification?: Maybe<Notification>;
  orderItemWasUpdated?: Maybe<OrderItem>;
  showPopupBannerForExpiringPromotions?: Maybe<ShowPopupBannerForExpiringPromotionsPayload>;
};

export type TmsCargoDetail = {
  deliveryAddress: Scalars['String'];
  id: Scalars['ID'];
  materialNumber: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['BigInt'];
  quantity: Scalars['Int'];
  receiptAddress: Scalars['String'];
};

/** The connection type for TmsCargoDetail. */
export type TmsCargoDetailConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TmsCargoDetailEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TmsCargoDetail>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TmsCargoDetailEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TmsCargoDetail>;
};

export type TmsTrip = {
  arrivedDeliveryAddressAt?: Maybe<Scalars['ISO8601DateTime']>;
  arrivedReceiptAddressAt?: Maybe<Scalars['ISO8601DateTime']>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']>;
  contactFullname: Scalars['String'];
  contactMobilephone: Scalars['String'];
  deliverySuccessfulAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliveryUnsuccessfulAt?: Maybe<Scalars['ISO8601DateTime']>;
  driverName: Scalars['String'];
  id: Scalars['ID'];
  itemCount: Scalars['Int'];
  items?: Maybe<TmsCargoDetailConnection>;
  locations: Array<TmsTripLocation>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status?: Maybe<Scalars['String']>;
  total: Scalars['BigInt'];
  totalQuantity: Scalars['Int'];
  tripId: Scalars['String'];
  vehicleCode: Scalars['String'];
};


export type TmsTripItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TmsTripLocation = {
  address: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  tmsUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  tripStatus: Scalars['String'];
};

export type Unit = {
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  englishName: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
  vietnameseName: Scalars['String'];
};

export type UnsaveProductInput = {
  productId: Scalars['ID'];
};

export type UpdateBranchInput = {
  email: Scalars['String'];
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCartInput = {
  buyerId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  sellerId?: InputMaybe<Scalars['ID']>;
  variantId: Scalars['ID'];
};

export type UpdateExecutionOrderItemInput = {
  executionOrderItemIds: Array<Scalars['ID']>;
};

export type UpdateOrderItemInput = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type UpdateQuotationInput = {
  customerId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  isGift?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  serveyCustomerId?: InputMaybe<Scalars['ID']>;
  variantId: Scalars['ID'];
};

export type UpdateServeyCustomerInput = {
  address: Scalars['String'];
  companyName: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type User = {
  active: Scalars['Boolean'];
  createPasswordToken?: Maybe<Scalars['String']>;
  customer: Customer;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  resetPasswordToken?: Maybe<Scalars['String']>;
  salesEmployee?: Maybe<SalesEmployee>;
  userType?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type UserPermission = {
  active: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type Variant = {
  available?: Maybe<Scalars['Boolean']>;
  bestDeal?: Maybe<GiftCampaign>;
  campaignIds?: Maybe<Array<Scalars['ID']>>;
  campaignPropratedPrices?: Maybe<Array<CampaignPropratedPrice>>;
  countryOfOrigin?: Maybe<Country>;
  createdAt: Scalars['ISO8601DateTime'];
  defaultImageUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<DiscountDetails>;
  discounts: Array<DiscountDetails>;
  exhausted?: Maybe<Scalars['Boolean']>;
  extraDataFiles?: Maybe<Array<ExtraDataFile>>;
  firstOrderDiscount?: Maybe<DiscountDetails>;
  giftCampaigns?: Maybe<Array<GiftCampaign>>;
  grossWeight?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  imageUrls: Array<Scalars['String']>;
  inventoryQuantity?: Maybe<Scalars['Int']>;
  levelableGiftCampaigns?: Maybe<Array<LevelableGiftCampaign>>;
  maintenanceDetails?: Maybe<Scalars['String']>;
  materialNumber: Scalars['String'];
  minimumOrderQuantity: Scalars['Int'];
  mustBuyWithVariant?: Maybe<Variant>;
  name: Scalars['String'];
  netPrice?: Maybe<Scalars['Int']>;
  netWeight?: Maybe<Scalars['Int']>;
  noncombinableGiftCampaigns?: Maybe<Array<NoncombinableGiftCampaign>>;
  optionValues: Array<OptionValue>;
  packagingDescription?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  regionalNames: Array<Scalars['String']>;
  specifications?: Maybe<Scalars['JSON']>;
  unavailableOptionValues: Scalars['JSON'];
  updatedAt: Scalars['ISO8601DateTime'];
  vatPrice?: Maybe<Scalars['Float']>;
  vatWholesalePrice?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['Int']>;
  volumeUnit: Unit;
  warranty?: Maybe<Warranty>;
  weightUnit: Unit;
  wholesalePrice?: Maybe<Scalars['Int']>;
};


export type VariantDiscountArgs = {
  discountProgramId?: InputMaybe<Scalars['ID']>;
};

/** The connection type for Variant. */
export type VariantConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VariantEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Variant>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VariantEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Variant>;
};

export type VariantGiftCondition = {
  conditionItemSummary: Array<GiftConditionItem>;
  createdAt: Scalars['ISO8601DateTime'];
  giftConditionItemCount?: Maybe<Scalars['Int']>;
  giftConditionItems: Array<GiftConditionItem>;
  id: Scalars['ID'];
  totalGiftConditionItemsQuantityThreshold?: Maybe<Scalars['Int']>;
  totalGiftConditionItemsRevenueThreshold?: Maybe<Scalars['Int']>;
  totalQuantityThreshold?: Maybe<Scalars['Int']>;
  totalRevenueThreshold?: Maybe<Scalars['BigInt']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type VariantSearch = {
  results: VariantConnection;
  searchId: Scalars['ID'];
};


export type VariantSearchResultsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type VerifyPhoneNumberInput = {
  otp: Scalars['String'];
  userId: Scalars['ID'];
};

export type Warranty = {
  exchangePolicy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  warrantyPolicy?: Maybe<Scalars['String']>;
};

export type WarrantyInformation = {
  currentPage?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<WarrantyInformationData>>;
  lastPage?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  total?: Maybe<Scalars['Int']>;
};

export type WarrantyInformationData = {
  branchNameName?: Maybe<Scalars['String']>;
  causeDelaysText?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  customerReflect?: Maybe<Scalars['String']>;
  errorPhenomenonName?: Maybe<Scalars['String']>;
  errorText?: Maybe<Scalars['String']>;
  guaranteeStatusName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  productCode: Scalars['String'];
  productName: Scalars['String'];
  receivedAt: Scalars['ISO8601Date'];
  returnedAt?: Maybe<Scalars['ISO8601Date']>;
  status: Scalars['String'];
  statusTitle: Scalars['String'];
  testResultName?: Maybe<Scalars['String']>;
};

export type WarrantyOrder = {
  createdAt: Scalars['ISO8601DateTime'];
  customer: Customer;
  id: Scalars['ID'];
  note: Scalars['String'];
  status: Scalars['String'];
  totalQuantity: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  warrantyOrderItems?: Maybe<WarrantyOrderItemConnection>;
};


export type WarrantyOrderWarrantyOrderItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for WarrantyOrder. */
export type WarrantyOrderConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WarrantyOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WarrantyOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type WarrantyOrderEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<WarrantyOrder>;
};

export type WarrantyOrderInput = {
  id?: InputMaybe<Scalars['ID']>;
  note: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};

export type WarrantyOrderItem = {
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  info?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  warrantyOrder: WarrantyOrder;
};

/** The connection type for WarrantyOrderItem. */
export type WarrantyOrderItemConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WarrantyOrderItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WarrantyOrderItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type WarrantyOrderItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<WarrantyOrderItem>;
};

export type WarrantyOrderItemInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  info?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  warrantyOrderId: Scalars['ID'];
};

export type WebpushTokenInput = {
  device?: InputMaybe<Scalars['String']>;
  endpoint: Scalars['String'];
  keysAuth: Scalars['String'];
  keysP256dh: Scalars['String'];
  oldKeysP256dh?: InputMaybe<Scalars['String']>;
};

export type GetOrderItemQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetOrderItemQuery = { orderItem: { id: string, quantity: number, vatWholesalePrice: any, totalPriceBeforeVat: any, wholesalePrice: any, vat: any, totalPrice: any, discounts: Array<{ id: string, name: string, percent?: number | null | undefined, type?: string | null | undefined, flatAmount?: number | null | undefined, applied?: boolean | null | undefined, vatAdjustment: number, adjustment: number, fromDate: any, toDate: any, requirements?: any | null | undefined }>, noncombinableGiftCampaigns?: Array<{ groupId: string, giftCampaignGroups?: Array<{ id: string, applied: boolean, type: string, campaignName: string, description: string, fromDate: any, toDate: any, multiplyBy: number, totalRewardsInCart?: number | null | undefined, remainingRewardTimes: number, remainingRewardTimesInCart?: number | null | undefined, level?: number | null | undefined, progressData?: Array<{ id: string, name: string, quantity: number, revenue: any, materialNumber?: string | null | undefined }> | null | undefined, selectedGifts?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, selectedGiftsInCart?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, requirements: Array<{ id: string, totalRevenueThreshold?: any | null | undefined, totalQuantityThreshold?: number | null | undefined, totalGiftConditionItemsRevenueThreshold?: number | null | undefined, totalGiftConditionItemsQuantityThreshold?: number | null | undefined, giftConditionItems: Array<{ id: string, revenueThreshold?: any | null | undefined, quantityThreshold?: number | null | undefined, propratedPrice?: any | null | undefined, variant: { id: string, name: string, materialNumber: string, vatWholesalePrice?: number | null | undefined } }> }>, gifts: Array<{ id: string, name?: string | null | undefined, description?: string | null | undefined, selectableQuantity: number, giftSelectionItemGroups: Array<{ groupId: string, itemCount: number, quantity: number, giftSelectionItems: Array<{ groupId?: number | null | undefined, id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, totalValue?: number | null | undefined, variant: { id: string, name: string, available?: boolean | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, netPrice?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }> }> | null | undefined }> | null | undefined, levelableGiftCampaigns?: Array<{ id: string, applied: boolean, type: string, campaignName: string, description: string, fromDate: any, toDate: any, multiplyBy: number, level?: number | null | undefined, remainingRewardTimes: number, selectedGifts?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, gifts: Array<{ id: string, name?: string | null | undefined, description?: string | null | undefined, selectableQuantity: number, giftSelectionItemGroups: Array<{ groupId: string, itemCount: number, quantity: number, giftSelectionItems: Array<{ groupId?: number | null | undefined, id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, totalValue?: number | null | undefined, variant: { id: string, name: string, available?: boolean | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, netPrice?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }>, requirements: Array<{ id: string, totalRevenueThreshold?: any | null | undefined, totalQuantityThreshold?: number | null | undefined, totalGiftConditionItemsRevenueThreshold?: number | null | undefined, totalGiftConditionItemsQuantityThreshold?: number | null | undefined, giftConditionItems: Array<{ id: string, revenueThreshold?: any | null | undefined, quantityThreshold?: number | null | undefined, propratedPrice?: any | null | undefined, variant: { id: string, name: string, materialNumber: string, vatWholesalePrice?: number | null | undefined } }> }>, giftCampaignChildren?: Array<{ id: string, applied: boolean, type: string, campaignName: string, description: string, fromDate: any, toDate: any, multiplyBy: number, level?: number | null | undefined, remainingRewardTimes: number, selectedGifts?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, requirements: Array<{ id: string, totalRevenueThreshold?: any | null | undefined, totalQuantityThreshold?: number | null | undefined, totalGiftConditionItemsRevenueThreshold?: number | null | undefined, totalGiftConditionItemsQuantityThreshold?: number | null | undefined, giftConditionItems: Array<{ id: string, revenueThreshold?: any | null | undefined, quantityThreshold?: number | null | undefined, propratedPrice?: any | null | undefined, variant: { id: string, name: string, materialNumber: string, vatWholesalePrice?: number | null | undefined } }> }>, gifts: Array<{ id: string, name?: string | null | undefined, description?: string | null | undefined, selectableQuantity: number, giftSelectionItemGroups: Array<{ groupId: string, itemCount: number, quantity: number, giftSelectionItems: Array<{ groupId?: number | null | undefined, id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, totalValue?: number | null | undefined, variant: { id: string, name: string, available?: boolean | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, netPrice?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }> }> | null | undefined }> | null | undefined, giftCampaigns?: Array<{ id: string, type: string, applied: boolean, campaignName: string, description: string, fromDate: any, toDate: any, level?: number | null | undefined, multiplyBy: number, totalRewardsInCart?: number | null | undefined, remainingRewardTimesInCart?: number | null | undefined, unconfirmedRewardTimesInCart?: number | null | undefined, remainingRewardTimes: number, progressData?: Array<{ id: string, materialNumber?: string | null | undefined, name: string, quantity: number, revenue: any }> | null | undefined, selectedGiftsInCart?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, selectedGifts?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, requirements: Array<{ id: string, totalRevenueThreshold?: any | null | undefined, totalQuantityThreshold?: number | null | undefined, giftConditionItems: Array<{ id: string, revenueThreshold?: any | null | undefined, quantityThreshold?: number | null | undefined, propratedPrice?: any | null | undefined, variant: { id: string, name: string, netPrice?: number | null | undefined } }> }>, gifts: Array<{ id: string, name?: string | null | undefined, description?: string | null | undefined, giftSelectionItemGroups: Array<{ groupId: string, itemCount: number, quantity: number, giftSelectionItems: Array<{ groupId?: number | null | undefined, id: string, quantity?: number | null | undefined, totalValue?: number | null | undefined, variant: { name: string, id: string, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, volume?: number | null | undefined, product?: { id: string } | null | undefined, volumeUnit: { id: string, code: string, englishName: string }, optionValues: Array<{ id: string, value: string }> } }> }> }> }> | null | undefined, order: { id: string, total: any, status: string }, variant: { id: string, name: string, inventoryQuantity?: number | null | undefined, materialNumber: string, netPrice?: number | null | undefined, product?: { id: string } | null | undefined, optionValues: Array<{ id: string, value: string }> } } };

export type GetCampaignDataByOrderItemQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetCampaignDataByOrderItemQuery = { orderItem: { id: string, noncombinableGiftCampaigns?: Array<{ groupId: string, giftCampaignGroups?: Array<{ id: string, applied: boolean, type: string, campaignName: string, description: string, multiplyBy: number, gifts: Array<{ id: string, name?: string | null | undefined, description?: string | null | undefined, selectableQuantity: number, giftSelectionItemGroups: Array<{ groupId: string, itemCount: number, quantity: number, giftSelectionItems: Array<{ groupId?: number | null | undefined, id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, totalValue?: number | null | undefined, variant: { id: string, name: string, available?: boolean | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, netPrice?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }> }> | null | undefined }> | null | undefined, levelableGiftCampaigns?: Array<{ id: string, applied: boolean, type: string, campaignName: string, description: string, multiplyBy: number, gifts: Array<{ id: string, name?: string | null | undefined, description?: string | null | undefined, selectableQuantity: number, giftSelectionItemGroups: Array<{ groupId: string, itemCount: number, quantity: number, giftSelectionItems: Array<{ groupId?: number | null | undefined, id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, totalValue?: number | null | undefined, variant: { id: string, name: string, available?: boolean | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, netPrice?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }>, giftCampaignChildren?: Array<{ id: string, applied: boolean, type: string, campaignName: string, description: string, multiplyBy: number, gifts: Array<{ id: string, name?: string | null | undefined, description?: string | null | undefined, selectableQuantity: number, giftSelectionItemGroups: Array<{ groupId: string, itemCount: number, quantity: number, giftSelectionItems: Array<{ groupId?: number | null | undefined, id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, totalValue?: number | null | undefined, variant: { id: string, name: string, available?: boolean | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, netPrice?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }> }> | null | undefined }> | null | undefined, giftCampaigns?: Array<{ id: string, type: string, applied: boolean, campaignName: string, description: string, multiplyBy: number, gifts: Array<{ id: string, name?: string | null | undefined, description?: string | null | undefined, selectableQuantity: number, giftSelectionItemGroups: Array<{ groupId: string, itemCount: number, quantity: number, giftSelectionItems: Array<{ groupId?: number | null | undefined, id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, totalValue?: number | null | undefined, variant: { id: string, name: string, available?: boolean | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, netPrice?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }> }> | null | undefined } };

export type GetCampaignSelectedGiftsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetCampaignSelectedGiftsQuery = { orderItem: { id: string, noncombinableGiftCampaigns?: Array<{ groupId: string, giftCampaignGroups?: Array<{ id: string, applied: boolean, totalRewardsInCart?: number | null | undefined, conditionCount: number, selectedGifts?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, selectedGiftsInCart?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined }> | null | undefined }> | null | undefined, levelableGiftCampaigns?: Array<{ id: string, applied: boolean, conditionCount: number, selectedGifts?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, giftCampaignChildren?: Array<{ id: string, applied: boolean, selectedGifts?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined }> | null | undefined }> | null | undefined, giftCampaigns?: Array<{ id: string, applied: boolean, totalRewardsInCart?: number | null | undefined, conditionCount: number, selectedGifts?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, selectedGiftsInCart?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined }> | null | undefined } };

export type GetOrderItemForCampaignsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetOrderItemForCampaignsQuery = { orderItem: { id: string, noncombinableGiftCampaigns?: Array<{ groupId: string, giftCampaignGroups?: Array<{ id: string, applied: boolean, type: string, campaignName: string, description: string, multiplyBy: number, totalRewardsInCart?: number | null | undefined, remainingRewardTimes: number, remainingRewardTimesInCart?: number | null | undefined, importableSameOrder: boolean, conditionCount: number, selectedGifts?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, selectedGiftsInCart?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, gifts: Array<{ id: string, name?: string | null | undefined, description?: string | null | undefined, selectableQuantity: number, giftSelectionItemGroups: Array<{ groupId: string, itemCount: number, quantity: number, giftSelectionItems: Array<{ groupId?: number | null | undefined, id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, totalValue?: number | null | undefined, variant: { id: string, name: string, available?: boolean | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, netPrice?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }> }> | null | undefined }> | null | undefined, levelableGiftCampaigns?: Array<{ id: string, applied: boolean, type: string, campaignName: string, description: string, multiplyBy: number, totalRewardsInCart?: number | null | undefined, remainingRewardTimes: number, remainingRewardTimesInCart?: number | null | undefined, importableSameOrder: boolean, conditionCount: number, selectedGifts?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, selectedGiftsInCart?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, gifts: Array<{ id: string, name?: string | null | undefined, description?: string | null | undefined, selectableQuantity: number, giftSelectionItemGroups: Array<{ groupId: string, itemCount: number, quantity: number, giftSelectionItems: Array<{ groupId?: number | null | undefined, id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, totalValue?: number | null | undefined, variant: { id: string, name: string, available?: boolean | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, netPrice?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }>, giftCampaignChildren?: Array<{ id: string, applied: boolean, type: string, campaignName: string, description: string, multiplyBy: number, totalRewardsInCart?: number | null | undefined, remainingRewardTimes: number, remainingRewardTimesInCart?: number | null | undefined, importableSameOrder: boolean, conditionCount: number, selectedGifts?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, selectedGiftsInCart?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, gifts: Array<{ id: string, name?: string | null | undefined, description?: string | null | undefined, selectableQuantity: number, giftSelectionItemGroups: Array<{ groupId: string, itemCount: number, quantity: number, giftSelectionItems: Array<{ groupId?: number | null | undefined, id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, totalValue?: number | null | undefined, variant: { id: string, name: string, available?: boolean | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, netPrice?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }> }> | null | undefined }> | null | undefined, giftCampaigns?: Array<{ id: string, type: string, applied: boolean, campaignName: string, description: string, multiplyBy: number, totalRewardsInCart?: number | null | undefined, remainingRewardTimes: number, remainingRewardTimesInCart?: number | null | undefined, importableSameOrder: boolean, conditionCount: number, selectedGifts?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, selectedGiftsInCart?: Array<{ id: string, status: string, orderId?: string | null | undefined, multiplyBy: number, giftBillingOption: string, giftSelection: { id: string, giftSelectionItemGroups: Array<{ quantity: number, groupId: string, giftSelectionItems: Array<{ id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, occupiedQuantity?: number | null | undefined, variant: { name: string, id: string, available?: boolean | null | undefined, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }, selectedGiftItems: Array<{ quantity: number, id: string, giftSelectionItem: { id: string, quantity?: number | null | undefined, groupId?: number | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, materialNumber: string, vatWholesalePrice?: number | null | undefined, grossWeight?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } } }> }> | null | undefined, gifts: Array<{ id: string, name?: string | null | undefined, description?: string | null | undefined, selectableQuantity: number, giftSelectionItemGroups: Array<{ groupId: string, itemCount: number, quantity: number, giftSelectionItems: Array<{ groupId?: number | null | undefined, id: string, quantity?: number | null | undefined, quantityInWarehouse?: number | null | undefined, totalValue?: number | null | undefined, variant: { id: string, name: string, available?: boolean | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, netPrice?: number | null | undefined, volume?: number | null | undefined, optionValues: Array<{ id: string, value: string }> } }> }> }> }> | null | undefined } };

export type GetOrderItemDrawerQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetOrderItemDrawerQuery = { orderItem: { id: string, quantity: number, vatWholesalePrice: any, totalPriceBeforeVat: any, wholesalePrice: any, vat: any, totalPrice: any, discounts: Array<{ id: string, name: string, percent?: number | null | undefined, type?: string | null | undefined, flatAmount?: number | null | undefined, applied?: boolean | null | undefined, vatAdjustment: number, adjustment: number, fromDate: any, toDate: any, requirements?: any | null | undefined }>, variant: { id: string, name: string, available?: boolean | null | undefined, exhausted?: boolean | null | undefined, minimumOrderQuantity: number, packagingDescription?: string | null | undefined, inventoryQuantity?: number | null | undefined, materialNumber: string, netPrice?: number | null | undefined, product?: { id: string } | null | undefined, optionValues: Array<{ id: string, value: string }> } } };

export type RemoveOrderItemsMutationVariables = Types.Exact<{
  input: Types.RemoveOrderItemsInput;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type RemoveOrderItemsMutation = { removeOrderItems?: { id: string, status: string, total: any, orderItems?: { totalCount: number, nodes?: Array<{ id: string, price: any, quantity: number, updatedAt: any, createdAt: any, vatWholesalePrice: any, totalPrice: any, anyImportableSameOrder: boolean, ownCampaignTypeA: boolean, hasAllGiftsSelected: boolean, userUpdater?: { id: string, name?: string | null | undefined, phoneNumber: string, email?: string | null | undefined } | null | undefined, variant: { name: string, id: string, netPrice?: number | null | undefined, vatPrice?: number | null | undefined, campaignIds?: Array<string> | null | undefined, inventoryQuantity?: number | null | undefined, materialNumber: string, defaultImageUrl?: string | null | undefined, vatWholesalePrice?: number | null | undefined, volume?: number | null | undefined, discounts: Array<{ id: string, name: string, percent?: number | null | undefined, type?: string | null | undefined, flatAmount?: number | null | undefined, applied?: boolean | null | undefined, vatAdjustment: number, adjustment: number, fromDate: any, toDate: any, requirements?: any | null | undefined }>, product?: { id: string } | null | undefined, volumeUnit: { code: string }, optionValues: Array<{ id: string, value: string }> }, discounts: Array<{ id: string, name: string, percent?: number | null | undefined, type?: string | null | undefined, flatAmount?: number | null | undefined, applied?: boolean | null | undefined, vatAdjustment: number, adjustment: number, fromDate: any, toDate: any, requirements?: any | null | undefined }> } | null | undefined> | null | undefined, pageInfo: { hasNextPage: boolean, endCursor?: string | null | undefined } } | null | undefined } | null | undefined };


export const GetOrderItemDocument = gql`
    query GetOrderItem($id: ID!) {
  orderItem(id: $id) {
    id
    quantity
    vatWholesalePrice
    totalPriceBeforeVat
    wholesalePrice
    vat
    totalPrice
    discounts {
      ...discount
    }
    noncombinableGiftCampaigns {
      groupId
      giftCampaignGroups {
        id
        applied
        type
        campaignName
        description
        fromDate
        toDate
        multiplyBy
        totalRewardsInCart
        progressData {
          ...progressData
        }
        remainingRewardTimes
        remainingRewardTimesInCart
        selectedGifts {
          ...selectedGifts
        }
        selectedGiftsInCart {
          ...selectedGifts
        }
        requirements {
          ...requirement
        }
        level
        gifts {
          ...gift
        }
      }
    }
    levelableGiftCampaigns {
      id
      applied
      type
      campaignName
      description
      fromDate
      toDate
      multiplyBy
      level
      remainingRewardTimes
      selectedGifts {
        ...selectedGifts
      }
      gifts {
        ...gift
      }
      requirements {
        ...requirement
      }
      giftCampaignChildren {
        id
        applied
        type
        campaignName
        description
        fromDate
        toDate
        multiplyBy
        level
        remainingRewardTimes
        selectedGifts {
          ...selectedGifts
        }
        requirements {
          ...requirement
        }
        gifts {
          ...gift
        }
      }
    }
    giftCampaigns {
      id
      type
      applied
      campaignName
      description
      fromDate
      toDate
      progressData {
        id
        materialNumber
        name
        quantity
        revenue
      }
      level
      multiplyBy
      totalRewardsInCart
      remainingRewardTimesInCart
      unconfirmedRewardTimesInCart
      remainingRewardTimes
      selectedGiftsInCart {
        id
        status
        orderId
        multiplyBy
        giftSelection {
          id
          giftSelectionItemGroups {
            quantity
            giftSelectionItems {
              id
              quantity
              variant {
                name
                id
                netPrice
                materialNumber
                vatWholesalePrice
                optionValues {
                  id
                  value
                }
              }
            }
          }
        }
        selectedGiftItems {
          giftSelectionItem {
            id
            quantity
            variant {
              name
              id
              netPrice
              materialNumber
              defaultImageUrl
              vatWholesalePrice
              optionValues {
                id
                value
              }
            }
          }
          quantity
          id
        }
        giftBillingOption
      }
      selectedGifts {
        id
        status
        orderId
        multiplyBy
        giftSelection {
          id
          giftSelectionItemGroups {
            quantity
            giftSelectionItems {
              id
              quantity
              variant {
                name
                id
                netPrice
                materialNumber
                vatWholesalePrice
                optionValues {
                  id
                  value
                }
              }
            }
          }
        }
        selectedGiftItems {
          giftSelectionItem {
            id
            quantity
            variant {
              name
              id
              netPrice
              materialNumber
              defaultImageUrl
              vatWholesalePrice
              optionValues {
                id
                value
              }
            }
          }
          quantity
          id
        }
        giftBillingOption
      }
      requirements {
        id
        totalRevenueThreshold
        totalQuantityThreshold
        giftConditionItems {
          id
          revenueThreshold
          quantityThreshold
          propratedPrice
          variant {
            id
            name
            netPrice
          }
        }
      }
      gifts {
        id
        name
        description
        giftSelectionItemGroups {
          groupId
          itemCount
          quantity
          giftSelectionItems {
            groupId
            id
            quantity
            totalValue
            variant {
              name
              id
              materialNumber
              defaultImageUrl
              vatWholesalePrice
              volume
              product {
                id
              }
              volumeUnit {
                id
                code
                englishName
              }
              optionValues {
                id
                value
              }
            }
          }
        }
      }
    }
    order {
      id
      total
      status
    }
    variant {
      id
      name
      inventoryQuantity
      product {
        id
      }
      materialNumber
      netPrice
      optionValues {
        id
        value
      }
    }
  }
}
    ${DiscountFragmentDoc}
${ProgressDataFragmentDoc}
${SelectedGiftsFragmentDoc}
${RequirementFragmentDoc}
${GiftFragmentDoc}`;

/**
 * __useGetOrderItemQuery__
 *
 * To run a query within a React component, call `useGetOrderItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderItemQuery(baseOptions: Apollo.QueryHookOptions<GetOrderItemQuery, GetOrderItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderItemQuery, GetOrderItemQueryVariables>(GetOrderItemDocument, options);
      }
export function useGetOrderItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderItemQuery, GetOrderItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderItemQuery, GetOrderItemQueryVariables>(GetOrderItemDocument, options);
        }
export type GetOrderItemQueryHookResult = ReturnType<typeof useGetOrderItemQuery>;
export type GetOrderItemLazyQueryHookResult = ReturnType<typeof useGetOrderItemLazyQuery>;
export type GetOrderItemQueryResult = Apollo.QueryResult<GetOrderItemQuery, GetOrderItemQueryVariables>;
export const GetCampaignDataByOrderItemDocument = gql`
    query GetCampaignDataByOrderItem($id: ID!) {
  orderItem(id: $id) {
    id
    noncombinableGiftCampaigns {
      groupId
      giftCampaignGroups {
        id
        applied
        type
        campaignName
        description
        multiplyBy
        gifts {
          ...gift
        }
      }
    }
    levelableGiftCampaigns {
      id
      applied
      type
      campaignName
      description
      multiplyBy
      gifts {
        ...gift
      }
      giftCampaignChildren {
        id
        applied
        type
        campaignName
        description
        multiplyBy
        gifts {
          ...gift
        }
      }
    }
    giftCampaigns {
      id
      type
      applied
      campaignName
      description
      multiplyBy
      gifts {
        ...gift
      }
    }
  }
}
    ${GiftFragmentDoc}`;

/**
 * __useGetCampaignDataByOrderItemQuery__
 *
 * To run a query within a React component, call `useGetCampaignDataByOrderItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignDataByOrderItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignDataByOrderItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignDataByOrderItemQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignDataByOrderItemQuery, GetCampaignDataByOrderItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignDataByOrderItemQuery, GetCampaignDataByOrderItemQueryVariables>(GetCampaignDataByOrderItemDocument, options);
      }
export function useGetCampaignDataByOrderItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignDataByOrderItemQuery, GetCampaignDataByOrderItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignDataByOrderItemQuery, GetCampaignDataByOrderItemQueryVariables>(GetCampaignDataByOrderItemDocument, options);
        }
export type GetCampaignDataByOrderItemQueryHookResult = ReturnType<typeof useGetCampaignDataByOrderItemQuery>;
export type GetCampaignDataByOrderItemLazyQueryHookResult = ReturnType<typeof useGetCampaignDataByOrderItemLazyQuery>;
export type GetCampaignDataByOrderItemQueryResult = Apollo.QueryResult<GetCampaignDataByOrderItemQuery, GetCampaignDataByOrderItemQueryVariables>;
export const GetCampaignSelectedGiftsDocument = gql`
    query GetCampaignSelectedGifts($id: ID!) {
  orderItem(id: $id) {
    id
    noncombinableGiftCampaigns {
      groupId
      giftCampaignGroups {
        id
        applied
        totalRewardsInCart
        conditionCount
        selectedGifts {
          ...selectedGifts
        }
        selectedGiftsInCart {
          ...selectedGifts
        }
      }
    }
    levelableGiftCampaigns {
      id
      applied
      conditionCount
      selectedGifts {
        ...selectedGifts
      }
      giftCampaignChildren {
        id
        applied
        selectedGifts {
          ...selectedGifts
        }
      }
    }
    giftCampaigns {
      id
      applied
      totalRewardsInCart
      conditionCount
      selectedGifts {
        ...selectedGifts
      }
      selectedGiftsInCart {
        ...selectedGifts
      }
    }
  }
}
    ${SelectedGiftsFragmentDoc}`;

/**
 * __useGetCampaignSelectedGiftsQuery__
 *
 * To run a query within a React component, call `useGetCampaignSelectedGiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignSelectedGiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignSelectedGiftsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignSelectedGiftsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignSelectedGiftsQuery, GetCampaignSelectedGiftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignSelectedGiftsQuery, GetCampaignSelectedGiftsQueryVariables>(GetCampaignSelectedGiftsDocument, options);
      }
export function useGetCampaignSelectedGiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignSelectedGiftsQuery, GetCampaignSelectedGiftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignSelectedGiftsQuery, GetCampaignSelectedGiftsQueryVariables>(GetCampaignSelectedGiftsDocument, options);
        }
export type GetCampaignSelectedGiftsQueryHookResult = ReturnType<typeof useGetCampaignSelectedGiftsQuery>;
export type GetCampaignSelectedGiftsLazyQueryHookResult = ReturnType<typeof useGetCampaignSelectedGiftsLazyQuery>;
export type GetCampaignSelectedGiftsQueryResult = Apollo.QueryResult<GetCampaignSelectedGiftsQuery, GetCampaignSelectedGiftsQueryVariables>;
export const GetOrderItemForCampaignsDocument = gql`
    query GetOrderItemForCampaigns($id: ID!) {
  orderItem(id: $id) {
    id
    noncombinableGiftCampaigns {
      groupId
      giftCampaignGroups {
        id
        applied
        type
        campaignName
        description
        multiplyBy
        totalRewardsInCart
        remainingRewardTimes
        remainingRewardTimesInCart
        importableSameOrder
        conditionCount
        selectedGifts {
          ...selectedGifts
        }
        selectedGiftsInCart {
          ...selectedGifts
        }
        gifts {
          ...gift
        }
      }
    }
    levelableGiftCampaigns {
      id
      applied
      type
      campaignName
      description
      multiplyBy
      totalRewardsInCart
      remainingRewardTimes
      remainingRewardTimesInCart
      importableSameOrder
      conditionCount
      selectedGifts {
        ...selectedGifts
      }
      selectedGiftsInCart {
        ...selectedGifts
      }
      gifts {
        ...gift
      }
      giftCampaignChildren {
        id
        applied
        type
        campaignName
        description
        multiplyBy
        totalRewardsInCart
        remainingRewardTimes
        remainingRewardTimesInCart
        importableSameOrder
        conditionCount
        selectedGifts {
          ...selectedGifts
        }
        selectedGiftsInCart {
          ...selectedGifts
        }
        gifts {
          ...gift
        }
      }
    }
    giftCampaigns {
      id
      type
      applied
      campaignName
      description
      multiplyBy
      totalRewardsInCart
      remainingRewardTimes
      remainingRewardTimesInCart
      importableSameOrder
      conditionCount
      selectedGifts {
        ...selectedGifts
      }
      selectedGiftsInCart {
        ...selectedGifts
      }
      gifts {
        ...gift
      }
    }
  }
}
    ${SelectedGiftsFragmentDoc}
${GiftFragmentDoc}`;

/**
 * __useGetOrderItemForCampaignsQuery__
 *
 * To run a query within a React component, call `useGetOrderItemForCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderItemForCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderItemForCampaignsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderItemForCampaignsQuery(baseOptions: Apollo.QueryHookOptions<GetOrderItemForCampaignsQuery, GetOrderItemForCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderItemForCampaignsQuery, GetOrderItemForCampaignsQueryVariables>(GetOrderItemForCampaignsDocument, options);
      }
export function useGetOrderItemForCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderItemForCampaignsQuery, GetOrderItemForCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderItemForCampaignsQuery, GetOrderItemForCampaignsQueryVariables>(GetOrderItemForCampaignsDocument, options);
        }
export type GetOrderItemForCampaignsQueryHookResult = ReturnType<typeof useGetOrderItemForCampaignsQuery>;
export type GetOrderItemForCampaignsLazyQueryHookResult = ReturnType<typeof useGetOrderItemForCampaignsLazyQuery>;
export type GetOrderItemForCampaignsQueryResult = Apollo.QueryResult<GetOrderItemForCampaignsQuery, GetOrderItemForCampaignsQueryVariables>;
export const GetOrderItemDrawerDocument = gql`
    query GetOrderItemDrawer($id: ID!) {
  orderItem(id: $id) {
    id
    quantity
    vatWholesalePrice
    totalPriceBeforeVat
    wholesalePrice
    vat
    totalPrice
    discounts {
      ...discount
    }
    variant {
      id
      name
      available
      exhausted
      minimumOrderQuantity
      packagingDescription
      inventoryQuantity
      product {
        id
      }
      materialNumber
      netPrice
      optionValues {
        id
        value
      }
    }
  }
}
    ${DiscountFragmentDoc}`;

/**
 * __useGetOrderItemDrawerQuery__
 *
 * To run a query within a React component, call `useGetOrderItemDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderItemDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderItemDrawerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderItemDrawerQuery(baseOptions: Apollo.QueryHookOptions<GetOrderItemDrawerQuery, GetOrderItemDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderItemDrawerQuery, GetOrderItemDrawerQueryVariables>(GetOrderItemDrawerDocument, options);
      }
export function useGetOrderItemDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderItemDrawerQuery, GetOrderItemDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderItemDrawerQuery, GetOrderItemDrawerQueryVariables>(GetOrderItemDrawerDocument, options);
        }
export type GetOrderItemDrawerQueryHookResult = ReturnType<typeof useGetOrderItemDrawerQuery>;
export type GetOrderItemDrawerLazyQueryHookResult = ReturnType<typeof useGetOrderItemDrawerLazyQuery>;
export type GetOrderItemDrawerQueryResult = Apollo.QueryResult<GetOrderItemDrawerQuery, GetOrderItemDrawerQueryVariables>;
export const RemoveOrderItemsDocument = gql`
    mutation RemoveOrderItems($input: RemoveOrderItemsInput!, $first: Int, $after: String) {
  removeOrderItems(input: $input) {
    id
    orderItems(first: $first, after: $after) {
      nodes {
        id
        price
        quantity
        updatedAt
        createdAt
        vatWholesalePrice
        totalPrice
        anyImportableSameOrder
        ownCampaignTypeA
        hasAllGiftsSelected
        updatedAt
        userUpdater {
          id
          name
          phoneNumber
          email
        }
        variant {
          name
          id
          netPrice
          vatPrice
          campaignIds
          inventoryQuantity
          discounts {
            ...discount
          }
          materialNumber
          defaultImageUrl
          vatWholesalePrice
          volume
          product {
            id
          }
          volumeUnit {
            code
          }
          optionValues {
            id
            value
          }
        }
        discounts {
          ...discount
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
    status
    total
  }
}
    ${DiscountFragmentDoc}`;
export type RemoveOrderItemsMutationFn = Apollo.MutationFunction<RemoveOrderItemsMutation, RemoveOrderItemsMutationVariables>;

/**
 * __useRemoveOrderItemsMutation__
 *
 * To run a mutation, you first call `useRemoveOrderItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrderItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrderItemsMutation, { data, loading, error }] = useRemoveOrderItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRemoveOrderItemsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrderItemsMutation, RemoveOrderItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrderItemsMutation, RemoveOrderItemsMutationVariables>(RemoveOrderItemsDocument, options);
      }
export type RemoveOrderItemsMutationHookResult = ReturnType<typeof useRemoveOrderItemsMutation>;
export type RemoveOrderItemsMutationResult = Apollo.MutationResult<RemoveOrderItemsMutation>;
export type RemoveOrderItemsMutationOptions = Apollo.BaseMutationOptions<RemoveOrderItemsMutation, RemoveOrderItemsMutationVariables>;